module.exports = __webpack_public_path__ + "assets/Label.3c7317a372b5592effa92028fbf8f2b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/Label.jpg
// module id = 1056
// module chunks = 0